export enum Network {
  Mainnet = 1,
  Rinkeby = 4,
  // Playnet = 21,
}
